var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactCardPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#2837AA",
    fillOpacity: 0.1,
    transform: "translate(-313 -814) translate(8 409) translate(73 277) translate(232 128)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7896D2",
    d: "M15.198 14.022l-1.482-1.838c-.302-.378-.877-.463-1.3-.196-.438.28-.74.463-.816.505-.726.393-1.769-.744-2.691-2.217-.922-1.473-1.346-2.721-.62-3.1.09-.042.408-.197.877-.407.453-.21.665-.702.468-1.136l-.982-2.105c-.166-.365-.59-.575-1.013-.519-.575.084-1.194.295-1.497.449-1.723.926-1.496 4.63.68 8.11 2.162 3.464 5.458 5.415 7.181 4.503.303-.169.817-.562 1.18-.982.257-.31.272-.758.015-1.067z",
    transform: "translate(-313 -814) translate(8 409) translate(73 277) translate(232 128)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactCardPhone);
export default __webpack_public_path__ + "static/media/contactCardPhone.b74b62f803cff1b5ea5a5afbfc326066.svg";
export { ForwardRef as ReactComponent };